export default __webpack_public_path__ + "static/media/large-frame-bg1.ada7eef6.svg";